import { message, Skeleton } from 'antd';
import React, { useState } from 'react';
import { faNumber } from 'utils/common.util';
import AntButton from 'components/Common/AntButton';
import AntComment from 'components/Common/AntComment';
import fa from 'locales/fa.json';
import { EventQuestionUrl, QuestionUrl, SendQuestionUrl } from 'services/routes';
import request from 'services/request';
import { SComment } from './style';
import { useRouter } from 'next/router';
import { QuestionsType } from 'types/course.type';

type QuestionType = {
  data: QuestionsType[];
  notAllowToAsk?: boolean;
  register: boolean;
  isEvent?: boolean;
};

const Questions: React.FC<QuestionType> = (props) => {
  const { data, register, notAllowToAsk, isEvent } = props;
  const router = useRouter();
  const [loading, setLoading] = useState(null);
  const [allData, setAllData] = useState(data);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('');
  const [page, setPage] = useState(1);
  const { courseId, lessonId, eventId } = router.query;

  const handleLoadMore = async (): Promise<void> => {
    setLoading('loadMore');
    const res: any = await request.get(QuestionUrl(courseId)); // eslint-disable-line
    setLoading(null);
    res.ok && setPage(page + 1);
    res.ok && setAllData([...allData, ...res.data.data]);
  };

  const handleSubmit = async (): Promise<void> => {
    const body = { title, description };
    const url = isEvent ? EventQuestionUrl(eventId) : SendQuestionUrl(courseId, lessonId);
    setLoading('send');
    const res: any = await request.post(url, body); // eslint-disable-line
    setLoading(null);
    if (res.ok) {
      message.success(res.data.message);
      setDescription('');
      setTitle('');
    } else {
      message.warn(res.data.message);
    }
  };

  return (
    <div className="h-full overflow-hidden relative">
      <div
        className={`${
          register && (!notAllowToAsk || isEvent) ? 'h-[calc(100%-240px)]' : 'h-full'
        }  overflow-auto`}
      >
        {!allData.length && <p className="toLeft p-[10px]">{fa.global.noQuestionYet}</p>}
        {allData.map((item) => (
          <AntComment
            text={item.description}
            avatar={item.user_favorite}
            name={item.title}
            date={faNumber(item?.created_at?.split(' ')[0])}
            key={item.title}
          >
            {item.answers &&
              item.answers.map((key) => (
                <AntComment
                  key={key.id}
                  text={key.content || key.voice}
                  voice={!!key.voice}
                  name={key.nickname}
                  date={faNumber(key?.answer_time.split(' ')[0])}
                />
              ))}
          </AntComment>
        ))}
        {allData.length === 20 * page && (
          <div className="w-full px-[30px] text-center mb-[30px]">
            {loading ? (
              <Skeleton active />
            ) : (
              <AntButton width="200px" onClick={handleLoadMore}>
                {fa.course.loadMore}
              </AntButton>
            )}
          </div>
        )}
      </div>
      {register && (!notAllowToAsk || isEvent) && (
        <div className="w-full center flex-col toLeft text-[16px]">
          <div>
            <div className="self-start pr-[8px] text-[13px] mt-[12px]">
              {fa.global.title}
            </div>
            <input
              className="border border-gray-5 rounded-[8px] w-[270px] md:w-[300px] h-[40px] p-[10px]"
              placeholder={global.title}
              value={title}
              onChange={(e): void => setTitle(e.target.value)}
            />
          </div>

          <textarea
            onChange={(e): void => setDescription(e.target.value)}
            placeholder={fa.global.description}
            value={description}
            className="border border-gray-5 rounded-[8px] w-[270px] md:w-[300px] h-[100px] my-[15px] p-[10px]"
          />
          <SComment
            onClick={handleSubmit}
            loading={loading === 'send'}
            disabled={!(description && title)}
          >
            {fa.course.sendQuestion}
          </SComment>
        </div>
      )}
    </div>
  );
};

export default Questions;
